import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';

const selector = state => get(state, SCOPE);

export const selectedColumnsSelector = createSelector(
  selector,
  store => store.selectedColumns,
);

export default selector;
